import React from 'react';
import { ErrorPageTemplate } from 'components/templates/ErrorPageTemplate';
import { EErrorPageType } from 'models/errorPage';

export const NotFoundPage = () => <ErrorPageTemplate type={EErrorPageType.NotFound} />;
